import {HtmlTekst, StorStreng, TilgangsrolleMedlem} from "../tjenester/ressurser/generertNg2HttpKlient";
import {standard} from "felles-ng2/støttefunksjoner/nilsjekk";
import {Brukerkontekst} from "felles-ng2/tjenester/Brukerkontekst";
import {erIkkeTomStreng, erTomEllerNil, sammenliknAlfanumerisk} from "felles-ng2/støttefunksjoner/strenger";
import {BeslutningModellDLM} from "felles-ng2/tjenester/datalager/BeslutningDatatjeneste";

export function beslutningsforslag<T extends BeslutningModellDLM>(beslutninger: T[]): T[] {
    return beslutninger.filter(beslutning => beslutning.erForslag);
}

export function endeligeBeslutninger<T extends BeslutningModellDLM>(beslutninger: T[]): T[] {
    return beslutninger.filter(beslutning => !beslutning.erForslag);
}

export function nullsikkerBeslutningTittelEllerForslag(beslutning: BeslutningModellDLM): StorStreng {
    const tittel = beslutning.erForslag ?
      beslutning.tittelForslag : beslutning.tittel;
    return standard(tittel, '');
}

export function beslutningBeskrivelseEllerForslag(beslutning: BeslutningModellDLM): HtmlTekst {
    return beslutning.erForslag ?
      beslutning.beskrivelseForslag : beslutning.beskrivelse;
}

/** Sann dersom beslutningen er migrert fra sp2 der tittel = null og alt tekstinnhold ligger i beskrivelse-feltet */
export function erMigrertBeslutning(beslutning: BeslutningModellDLM): boolean {
    return erTomEllerNil(beslutning.tittel) && erTomEllerNil(beslutning.tittelForslag);
}

export function harBeslutningsforslagtekst(beslutning: BeslutningModellDLM): boolean {
    return erIkkeTomStreng(beslutning.tittelForslag);
}

/** Returnerer 'beskrivelse'/'beskrivelseForslag' dersom beslutning er migrert fra sp2 (og tittelfeltet ikke er angitt ved senere redigeringer),
 * ellers 'tittel' dersom beslutning er endelig, ellers 'tittelForslag'
 * Merk at tittel er ren tekst med beskrivelse kan være html-formatert */
function beslutningTittelBeregnet(beslutning: BeslutningModellDLM): string {
    return erMigrertBeslutning(beslutning) ?
      beslutningBeskrivelseEllerForslag(beslutning) :
      nullsikkerBeslutningTittelEllerForslag(beslutning);
}

/** Sorterer beslutninger etter tittel stigende.
 * Returnerer negativt tall dersom a sorterer før b, positivt dersom a sorterer etter b, 0 dersom like.
 * Må holdes i synk med no.systemfabrikken.lederplan.domene.sak.Beslutning#compareTo */
export function sorterBeslutning<T extends BeslutningModellDLM>(a: T, b: T): number {
    if (a === b) return 0;

    let sortering = sammenliknAlfanumerisk(beslutningTittelBeregnet(a), beslutningTittelBeregnet(b))
    if (sortering != 0) return sortering;

    return a.id.localeCompare(b.id);
}

/** Sann dersom bruker kan redigere beslutning */
export function kanBeslutningRedigeres(beslutning: BeslutningModellDLM, kontekst: Brukerkontekst): boolean {
    return kontekst.inneharTilgangsrolleIGruppe(TilgangsrolleMedlem.skrive, beslutning.eiendeGruppeId);
}
